import createDebug from "debug";

/**
 * Namespaced debug logger for the babylon package.
 *
 * Silent by default; enable in the browser with
 * `localStorage.debug = "tony:babylon:*"` (or a specific namespace such
 * as `tony:babylon:stage`), then reload.
 */
export function getLogger(namespace: string) {
  return createDebug(`tony:babylon:${namespace}`);
}
